<div class="flex flex-col gap-2">
    <div class="flex gap-2 items-center">
        <app-avatar [name]="data?.user?.name"></app-avatar>
        <span class="font-semibold text-lg">{{ data?.user?.name }}</span>
        <app-status [value]="data?.user?.status"></app-status>
    </div>
    <div class="flex flex-wrap mt-3">
        <div class="flex flex-col col-4 gap-2">
            <span class="text-gray-500">Email</span>
            <a href="mailto:{{ data?.user?.email }}">{{ data?.user?.email }}</a>
        </div>

        <div class="flex flex-col col-4 gap-2">
            <span class="text-gray-500">Role</span>
            <app-role [value]="data?.user?.role"></app-role>
        </div>

        <div class="flex flex-col col-4 gap-2">
            <span class="text-gray-500">Phone</span>
            @if (data?.user?.phone) {
                <a href="tel:{{ data?.user?.phone }}">{{ data?.user?.phone }}</a>
            } @else {
                <span>{{ data?.user?.phone  | valueOr }}</span>
            }
        </div>

        <div class="flex flex-col col-4 gap-2">
            <span class="text-gray-500">Auth Provider</span>
            <span>{{ data?.user?.auth_provider }}</span>
        </div>

        <div class="flex flex-col col-4 gap-2">
            <span class="text-gray-500">Created At</span>
            <span>{{ data?.user?.created_at | date: 'short' | valueOr }}</span>
        </div>

        <div class="flex flex-col col-4 gap-2">
            <span class="text-gray-500">Last Login</span>
            <span>{{ data?.user?.last_login | date: 'short' | valueOr }}</span>
        </div>
    </div>
</div>
